import clsx from 'clsx';
import { createElement, ReactNode } from 'react';

export interface CardProps {
    /** Element to render: `section` for a titled block, `li` inside a list. */
    as?: 'div' | 'section' | 'li' | 'article';
    /** `md` = 16 px (20 px from 640 px), `lg` = 16 px (24 px, form sections), `none` for content that brings its own padding (tables, state blocks). */
    padding?: 'md' | 'lg' | 'none';
    /** `warning` = this card needs a person now. */
    tone?: 'surface' | 'warning';
    className?: string;
    children: ReactNode;
}

/** The one card: 20 px radius, hairline instead of a border, no elevation. Popovers and dialogs use bg-raised, not this. */
export const Card = ({ as = 'div', padding = 'md', tone = 'surface', className, children }: CardProps) =>
    createElement(
        as,
        {
            className: clsx(
                'rounded-card shadow-hairline',
                tone === 'warning' ? 'bg-tone-warning-bg' : 'bg-surface',
                padding === 'md' && 'p-4 sm:p-5',
                padding === 'lg' && 'p-4 sm:p-6',
                className
            ),
        },
        children
    );
